export default "__VITE_ASSET__$Ea51WjB__";